export default __webpack_public_path__ + "static/media/welcomev2.97a26aa3.png";